import firebase from 'firebase';
import 'firebase/firestore';
// import 'firebase/functions';
import moment from 'moment';
import { dateFormat, serverDateFormat } from './utils.js'

// console.log(process.env.NODE_ENV)
// console.log(process.env.VUE_APP_AUTH_DOMAIN)
// Firebase init goes here
const config = {
	apiKey: process.env.VUE_APP_API_KEY,
    authDomain: process.env.VUE_APP_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_DATABASE_URL,
    projectId: process.env.VUE_APP_PROJECT_ID,
    storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_APP_ID,
    measurementId: process.env.VUE_APP_MEASUREMENT_ID
}

firebase.initializeApp(config)

// console.log(moment(startDateTimestamp.toDate(), "America/Santiago").utc().format(dateFormat), startDateTimestamp, fb.firestore.Timestamp.now().toDate());
// Firebase utils
const auth = firebase.auth()
const authPersistence = firebase.auth.Auth.Persistence
const currentTime = firebase.firestore.Timestamp.fromDate(new Date())
const currentUser = auth.currentUser
const db = firebase.firestore()
const storage = firebase.storage()
// const functions = firebase.functions();
const currentTimee = () => {
	return firebase.firestore.Timestamp.now()
}
const fromDate = (date) => {
	return firebase.firestore.Timestamp.fromDate(new Date(moment(date, dateFormat).format(serverDateFormat)))
}

const companyData = () => {
	return {
		name: process.env.VUE_APP_COMPANY_NAME,
		id: process.env.VUE_APP_COMPANY_ID,
		address1: process.env.VUE_APP_COMPANY_ADDRESS,
		address2: process.env.VUE_APP_COMPANY_ADDRESS2,
		city: process.env.VUE_APP_COMPANY_CITY,
		state: process.env.VUE_APP_COMPANY_STATE,
		zipCode: process.env.VUE_APP_COMPANY_ZIPCODE,
		logo: process.env.VUE_APP_COMPANY_BASE64LOGO,
		signature: process.env.VUE_APP_COMPANY_BASE64SIGNATURE
	}
}

// if (process.env.NODE_ENV == 'development') {
// 	// connect to firebase auth emulator
// 	// console.log(process.env)
// 	auth.useEmulator(process.env.VUE_APP_AUTH_DOMAIN)
// 	db.useEmulator(process.env.VUE_APP_DATABASE_URL, process.env.VUE_APP_DATABASE_PORT)
// 	storage.useEmulator(process.env.VUE_APP_STORAGE_BUCKET, process.env.VUE_APP_STORAGE_PORT)

// }

// const getBudgetNumber = functions.httpsCallable('getBudgetNumber');

// Firebase collections
const attendancesCollection = db.collection('attendances')
const computingMetricTypes = db.collection('computingMetricTypes')
const constantsCollection = db.collection('constants')
const contractTypesCollection = db.collection('contractTypes')
const costCentersCollection = db.collection('costCenters')
const dxfFilesCollection = db.collection('dxfFiles')
const invoicesCollection = db.collection('invoices')
const positionsCollection = db.collection('positions')
const providersCollection = db.collection('providers')
const purchaseOrdersCollection = db.collection('purchaseOrders')
const usersCollection = db.collection('users')
const workersCollection = db.collection('workers')

export {
	attendancesCollection,
	auth,
	authPersistence,
	companyData,
	computingMetricTypes,
	constantsCollection,
	contractTypesCollection,
	costCentersCollection,
	currentTime,
	currentTimee,
	currentUser,
	db,
	dxfFilesCollection,
	// getBudgetNumber,
	invoicesCollection,
	positionsCollection,
	providersCollection,
	purchaseOrdersCollection,
	storage,
	usersCollection,
	workersCollection,
	fromDate
}

